import { Gradient } from "./gradient.js"

/**
 * @memberOf Tee
 * @class Color and properties to draw lines.
 * @param {Tee.Chart} chart The parent chart this stroke object belongs to.
 */
export class Stroke {
	constructor(chart) {
		this.chart = chart
		this.fill = "black"
		this.size = 1
		this.join = "round"
		this.cap = "square"
		this.dash = null

		this._g = null
	}

	get gradient() {
		if (!this._g) {
			this._g = new Gradient(this.chart)
		}

		return this._g
	}

	prepare(fill, c) {
		c = c || this.chart.ctx

		const g = this._g

		c.strokeStyle = g && g.visible ? g.create(this.chart.bounds) : fill || this.fill
		c.lineWidth = this.size
		c.lineJoin = this.join
		c.lineCap = this.cap
		c.shadowColor = "transparent"

		if (c.setLineDash) {
			c.setLineDash(this.dash || [])
		} else if (c.mozCurrentTransform) {
			c.mozDash = this.dash
		} else if (this.chart.isChrome) {
			c.webkitLineDash = this.dash
		}
	}

	setChart(chart) {
		this.chart = chart

		if (this._g) {
			this._g.chart = chart
		}
	}
}
